module.exports = __webpack_public_path__ + "static/img/bg1.e4cde87b.png";